import { ONBOARDING_DRAFT_KEY } from "./constants";

export const getDraftKey = (email?: string) => {
  return `${ONBOARDING_DRAFT_KEY}_${email}`;
};

export const getOnboardingDraft = (email: string | undefined): Record<string, unknown> | null => {
  if (!email) {
    return null;
  }
  const saved = localStorage.getItem(getDraftKey(email));
  return saved ? JSON.parse(saved) : null;
};

export const updateOnboardingDraft = (email: string | undefined, data: Record<string, unknown>) => {
  if (!email) {
    return;
  }

  const key = getDraftKey(email);
  const existingDraft = getOnboardingDraft(email) || {};

  const hasChanged = JSON.stringify(existingDraft) !== JSON.stringify({ ...existingDraft, ...data });

  if (hasChanged) {
    const updatedDraft = { ...existingDraft, ...data };
    localStorage.setItem(key, JSON.stringify(updatedDraft));
  }
};

export const deleteOnboardingDraft = (email: string | undefined) => {
  if (!email) {
    return;
  }
  localStorage.removeItem(getDraftKey(email));
};
